<template>
    <div
        v-if="userWalletCards && userWalletCards.length > 0"
        class="w-full pt-24"
    >
        <h3 class="text-slate-800 dark:text-slate-100 text-3xl font-medium leading-9">
            Cards in your wallet that earn {{ programName }}
        </h3>

        <div
            v-for="userGroup in userWalletCards"
            :key="userGroup.user_id"
            class="flex flex-col"
        >
            <div class="flex items-center gap-2 pb-6 pt-6">
                <Icon icon="user" class="w-6 h-6 text-slate-800 dark:text-slate-100" />
                <span
                    class="text-slate-800 dark:text-slate-100 text-lg font-medium leading-7"
                >
                    {{ userGroup.user_name }}
                </span>
            </div>

            <div
                data-horizontal-scroll
                class="-ml-4 -mr-8 md:-mx-4 px-4 overflow-x-auto hide-scrollbar scroll-smooth touch-pan-x overscroll-x-contain"
                @dragstart.prevent
            >
                <div
                    class="flex items-start gap-6 flex-nowrap snap-x snap-proximity"
                >
                    <button
                        v-for="card in userGroup.cards"
                        :key="card.connected_account_id ?? card.id"
                        @click="$emit('navigate-to-card', card)"
                        class="flex flex-col w-[80%] md:w-[240px] flex-shrink-0 snap-start select-none text-left cursor-pointer rounded-lg transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2 p-2 -m-2 hover:opacity-70 active:opacity-50"
                        style="
                            touch-action: pan-x;
                            -webkit-user-drag: none;
                        "
                    >
                        <div
                            class="w-full aspect-[79/50] rounded-lg mb-3 snap-start"
                        >
                            <img
                                v-if="card.card_image"
                                :src="card.card_image"
                                :alt="card.title"
                                draggable="false"
                                class="w-full h-full rounded-lg object-contain pointer-events-none select-none"
                            />
                            <div
                                v-else
                                class="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex flex-col justify-between p-4"
                            >
                                <div
                                    class="flex justify-between items-start"
                                >
                                    <div
                                        class="text-white font-bold text-lg"
                                    >
                                        {{
                                            card.issuing_bank
                                                ? card.issuing_bank.toUpperCase()
                                                : 'CHASE'
                                        }}
                                    </div>
                                    <div
                                        class="text-white font-bold text-sm opacity-75"
                                    >
                                        {{
                                            card.card_type
                                                ? card.card_type.toUpperCase()
                                                : 'PERSONAL'
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="flex justify-between items-end"
                                >
                                    <div
                                        class="text-white font-mono text-sm"
                                    >
                                        &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull;
                                        {{ card.last_four || '0000' }}
                                    </div>
                                    <div
                                        class="text-white text-xs opacity-75"
                                    >
                                        VISA
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="flex flex-col items-start gap-1 self-stretch"
                        >
                            <h4
                                class="text-slate-800 dark:text-slate-100 text-base font-medium leading-6 text-ellipsis overflow-hidden"
                            >
                                {{ card.title }}
                                <span
                                    class="text-slate-500 dark:text-slate-400 text-sm font-normal"
                                >
                                    ({{ card.last_four }})
                                </span>
                            </h4>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

defineProps({
    userWalletCards: Array,
    programName: String,
});

defineEmits(['navigate-to-card']);
</script>
